import { render, staticRenderFns } from "./OperaOrgsWindow.vue?vue&type=template&id=32fc01c6&scoped=true&"
import script from "./OperaOrgsWindow.vue?vue&type=script&lang=js&"
export * from "./OperaOrgsWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaOrgsWindow.vue?vue&type=style&index=0&id=32fc01c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fc01c6",
  null
  
)

export default component.exports